import Popup from "../general/popup/Popup";
import AuthContainer from "./AuthContainer";

const AuthPopup = ({onHide}) => {

    return (
        <Popup>
            <div className="auth-popup-container">
                <AuthContainer onHide={onHide} />
            </div>
        </Popup>
    )

}

export default AuthPopup;